// Brands we see often, offered as you type so a name typed before is one tap
// rather than eighty characters spelled from memory. Suggestions only:
// anything can still be typed and nothing here is enforced.
//
// Calley, 2026-10-28: an Azazie bridesmaid dress was checked in as "Amaze"
// because autocorrect changed it, and nothing could be searched to find it
// again. The describe boxes now have autocorrect off; this is the other half.
//
// Calley, 2026-10-29: "why don't you have Balenciaga?". The first version
// took only brands seen on two or more pieces, which cut every house we had
// altered once: Balenciaga, Chanel, Dior, McQueen, Khaite, Loro Piana, The
// Row. Those are the names that matter most, because brand decides who to
// call before starting and what repair is possible. So the rule is now every
// real brand on our own orders, however few pieces, with the spellings put
// right (fxrybackend/scripts/fix-brand-spellings.js holds the same table).
//
// Left out: no-label markers ("NA", "N/A"), test rows, and the times a
// garment or a note went in the brand box.
//
// ⚠️ fxrypopup, fxryshop and fxrysuperadmin-v2 each carry a copy (the apps
// share no code). Keep the three the same.

export const COMMON_BRANDS = [
  "3Sixteen",
  "A Piece Apart",
  "Acne Studios",
  "aeja boutique",
  "Ag",
  "Agolde",
  "Akashi-Kama",
  "aknvas",
  "Alex Mill",
  "Alexander McQueen",
  "Alice + Olivia",
  "Amundsen",
  "Anine Bing",
  "Apt 9",
  "Argent",
  "Aritzia",
  "Armani",
  "Armani Collezioni",
  "ASKKNY",
  "AYR",
  "Azazie",
  "babaa",
  "Bad Son",
  "Balenciaga",
  "Banana Republic",
  "Barbour",
  "BareBottoms",
  "Berk of Burlington",
  "Bershka",
  "BHLDN",
  "Big Bud Press",
  "Big Mac",
  "Black Crane",
  "Bo& Tee",
  "Boden",
  "Bogner",
  "Brain Dead",
  "Brioni",
  "Brunello Cucinelli",
  "Buck Mason",
  "Caara",
  "California Arts",
  "Calypso",
  "Canali",
  "Cappelli",
  "Capri",
  "Carhartt",
  "Caroline H",
  "Caron Callahan",
  "Cashmere & Company (vintage)",
  "Chanel",
  "Chloe Sevigny",
  "Christian Dior",
  "Citizens of Humanity",
  "Club Monaco",
  "Comme des Garçons",
  "Coolibar",
  "COS",
  "De Bonne Facture",
  "Desigual",
  "Diane Von Furstenberg",
  "Dickies",
  "Ditch",
  "DKNY",
  "Dockers",
  "Doen",
  "Donna Karan",
  "Dries Van Noten",
  "Dry Bones",
  "DUER",
  "Duluth",
  "Eighteen East",
  "Eileen Fisher",
  "Elle",
  "ellos",
  "essentials",
  "Everlane",
  "Express",
  "Faherty",
  "Falcon",
  "Falconeri",
  "Filson",
  "Flint & Tinder",
  "FRAME",
  "Gap",
  "Garnet Hill",
  "Gesso",
  "Giorgio Armani",
  "Go Lightly",
  "Good America",
  "Gramicci",
  "Great Northwest Indigo",
  "Greyson",
  "Gucci",
  "Guess",
  "Gustin",
  "Halogen",
  "Hanes",
  "Hey Gang",
  "Hickey Freeman",
  "Hinge",
  "HMH",
  "Horny Toad",
  "House of Bruar",
  "Hudson",
  "Hugo Boss",
  "Icicle",
  "Imogene & Willie",
  "Ireland's Eye",
  "Iron Heart",
  "Isabel Marant",
  "J Jill",
  "J.Crew",
  "Jack Donnelly",
  "Jack Spade",
  "Jade of London",
  "James Street",
  "Jamie Haller",
  "Jenni Kayne",
  "Jigsaw",
  "Joe McCoy",
  "Joe McCoy MFG",
  "Jones New York",
  "Judith & Charles",
  "Jumper 1234",
  "Jungmaven",
  "Kamakura",
  "Karen Walker",
  "Kate Spade",
  "KC Spencer",
  "Khaite",
  "kisshoten",
  "Kordal",
  "KUHL",
  "L'Agence",
  "L'Atelier",
  "La Ligne",
  "La Perla",
  "Lachlan",
  "Lafayette 148",
  "Lauren Jean Co",
  "Left Field",
  "Leslie Evers",
  "Levi's",
  "Lingua Franca",
  "Liverpool",
  "LL Bean",
  "Loft",
  "Loop",
  "Loro Piana",
  "LouLou De Saison",
  "Love Shack Fancy",
  "Lucky",
  "Lulus",
  "Luna",
  "Madewell",
  "Maeve",
  "Maline Bergir",
  "Margaret O'Leary",
  "Maria McManus",
  "Marimekko",
  "Marine Layer",
  "Massimo Dutti",
  "Max Studio",
  "MaxMara",
  "ME+EM",
  "Milford",
  "Ministry of Supply",
  "MM Lafleur",
  "MNG",
  "Momotaro",
  "Mother",
  "Muskhane",
  "Naadam",
  "Naked & Famous",
  "Nike",
  "Nili Lotan",
  "Nintendo",
  "Nordstrom",
  "Nour Hammour",
  "Nudie Jeans",
  "Oni Denim",
  "Open Edit",
  "Or Slow",
  "Orolay",
  "Our Legacy",
  "Outdoor Research",
  "Pacsun",
  "Paige",
  "Paloma Wool",
  "Pas De Calais",
  "Patapampa",
  "Paul Smith",
  "Pendleton",
  "Perfecto Brand",
  "Peter Millar",
  "Pistola",
  "Polo",
  "Prairie Underground",
  "Proper Cloth",
  "Pure Blue Japan",
  "Purple Brand",
  "Purple Label Ralph Lauren",
  "Quarter Horse",
  "Quince",
  "Rachel Comey",
  "Rag & Bone",
  "Raide Research",
  "Rails",
  "Raleigh Denim",
  "Ralph Lauren",
  "Reformation",
  "Relwen",
  "Revelry",
  "Rick Owens",
  "Rogue Territory",
  "RRL",
  "Samurai Jeans",
  "Sandro",
  "Scarti Lab",
  "Schneiders",
  "Sezane",
  "Show Me Your Mumu",
  "Simkhai",
  "Slowear",
  "Smartwool",
  "Snow Peak",
  "Soeur",
  "Spanx",
  "Spier & Mackay",
  "St Michael",
  "St. John",
  "Still Here",
  "Studio D'Artisan",
  "Style & Co",
  "Sugar Cane",
  "Suit Supply",
  "Syoaiya",
  "Taylor Stitch",
  "Ted Baker",
  "Tekla",
  "Tender",
  "The Frankie Shop",
  "The Great",
  "The Hughes",
  "The J Peterman Company",
  "The Row",
  "Theory",
  "Tibi",
  "Toast",
  "Todd Snyder",
  "True Religion",
  "Ulla Johnson",
  "Untuckit",
  "valette",
  "Vanessa Bruno",
  "Veronica Beard",
  "Vince",
  "Vivienne Westwood",
  "Vuori",
  "We The Free",
  "Wilfred",
  "Wit & Wisdom",
  "Working Classics",
  "Xirena",
  "YMC",
  "You Must Create",
  "Yves Saint Laurent Rive Gauche",
  "Zac Posen",
  "Zadig & Voltaire",
  "Zara",
  "Zegna",
];
